import { NewOrderType, TNewOrderForm } from "@/entities/new-order";
import clsx from "clsx";
import React, { forwardRef } from "react";
import { useFormContext } from "react-hook-form";
import { useAppSelector } from "../../../../Hooks/redux/useAppSelector";
import basicElements from "../../../../Theme/basicElements.module.scss";
import modalsElements from "../../../../Theme/modalsElements.module.scss";
import BasicButton from "../../../../UI/BasicButton";
import RemoveCrossButton from "../../../../UI/RemoveCrossButton";
import {
  getTotalCurrentTypeName,
  getTotalKeywordsCountFromCountries,
  getTotalOrderCost,
  getTotalViewsCount,
} from "../../Helpers/CreateOrderHelpers";
import styled from "./styled.module.scss";

interface ICreateNewOrderModalProps {
  handleSubmitCreateNewOrder: () => void;
  onClose: () => void;
  isLoading: boolean;
}

const CreateNewOrderModal = forwardRef(
  (
    {
      handleSubmitCreateNewOrder,
      onClose,
      isLoading,
    }: ICreateNewOrderModalProps,
    ref: React.ForwardedRef<HTMLDivElement>,
  ) => {
    const { watch } = useFormContext<TNewOrderForm>();

    const { app, type, countriesList, attributesList } = watch();

    const { user } = useAppSelector((state) => state.clientDataSlice);

    return (
      <div
        className={clsx(
          modalsElements.modal_wrapper,
          styled.submit_campaign_modal,
        )}
        ref={ref}
        tabIndex={-1}
      >
        <div className={modalsElements.close_button_block}>
          <RemoveCrossButton onClick={onClose} />
        </div>
        <h3
          className={clsx(
            modalsElements.modal_title,
            styled.submit_campaign_modal_title,
          )}
        >
          Are you sure you want to start the promotion?
        </h3>
        <div className={styled.submit_campaign_modal_text_block}>
          <span
            className={clsx(
              basicElements.basic__content_text,
              styled.submit_campaign_modal_text,
            )}
          >
            Campaign price:{" "}
            <b>
              {app &&
                user &&
                type &&
                getTotalOrderCost(
                  app,
                  user,
                  countriesList,
                  type,
                  attributesList,
                ).toFixed(2)}{" "}
              $
            </b>
          </span>
          <span
            className={clsx(
              basicElements.basic__content_text,
              styled.submit_campaign_modal_text,
            )}
          >
            {" "}
            Total {!!type && getTotalCurrentTypeName(type)}:{" "}
            <b>{getTotalKeywordsCountFromCountries(countriesList)}</b>
          </span>
          {type === NewOrderType.install_with_views && (
            <span
              className={clsx(
                basicElements.basic__content_text,
                styled.submit_campaign_modal_text,
              )}
            >
              Total impressions: <b>{getTotalViewsCount(countriesList)}</b>
            </span>
          )}
        </div>
        <BasicButton
          onClick={handleSubmitCreateNewOrder}
          size="lg"
          text={isLoading ? "Sending" : "Ok"}
          variant="blue"
          disabled={isLoading}
        />
      </div>
    );
  },
);

export default CreateNewOrderModal;
